export const redirect = route => {
  window.location.href = route;
};

export const openNewTab = route => {
  window.open(route);
};
